module.exports = __webpack_public_path__ + "img/dreamgaming.f4e3ec51.jpg";